import React from 'react';
import { withContent } from '../../../hoc/withContext';
import './BigSaleBlock.scss';
import { IContent } from '../../../types';
import { getShopURL, sendEvent } from '../../../utils';
import Image from '../../UI/Image/Image';
import BackgroundImage from '../../UI/Image/BackgroundImageElement';

// @ts-ignore
import Fade from 'react-reveal/Fade';

interface IBigSaleBlockProps {
  context?: IContent;
}

const BigSaleBlock = ({ context }: IBigSaleBlockProps) => {
  const { big_sale } = context;
  const { is_active, title, image, cta, subtitle } = big_sale;

  return is_active && (
    <div className="block-container-big_sale">
      <BackgroundImage
        classNames={["block-big_sale"]}
        imageName="bg-big_sale-mobile.jpg"
      >
        <BackgroundImage
          classNames={["image"]}
          imageName={"bg-big_sale.jpg"}
        >
          <Fade delay={100} left duration={600} distance="50px">
            <Image
              imageName={image}
              altText=""
            />
          </Fade>
        </BackgroundImage>
        <div className="content">
          <div className="inner">
            <div className="block-title">{title}</div>
            <div className="block-subtitle">{subtitle}</div>
            {cta && cta.link && cta.title && (
              <div className="action">
                <a
                  className="buynow"
                  href={getShopURL() + cta.link}
                  onClick={() => sendEvent(cta.tracking)}
                  data-alt-text={cta.title}
                >
                  <span>{cta.title}</span>
                </a>
              </div>
            )}
          </div>
        </div>
      </BackgroundImage>
    </div>
  );
};

export default withContent(BigSaleBlock);
